import script from "./InputSelectSearch.vue?vue&type=script&setup=true&lang=ts"
export * from "./InputSelectSearch.vue?vue&type=script&setup=true&lang=ts"

import "./InputSelectSearch.vue?vue&type=style&index=0&id=1287967e&lang=css"

const __exports__ = script;

export default __exports__